import _Input from "antd/es/input";
import _Modal from "antd/es/modal";
import _Upload from "antd/es/upload";
import _message from "antd/es/message";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _Form from "antd/es/form";
import React, { Component } from 'react';
import UploadCommon from '@/components/common/Question/Upload';
import { getLocalText } from '@/utilities/language';
import IconFont from '@/components/common/IconFont';

// const { Dragger } = Upload;
var FormItem = _Form.Item;
var LongTextPC = /*#__PURE__*/function (_Component) {
  _inherits(LongTextPC, _Component);
  function LongTextPC(props) {
    var _this;
    _classCallCheck(this, LongTextPC);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(LongTextPC).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleCancel", function () {
      return _this.setState({
        previewVisible: false
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handlePreview", function (file) {
      _this.setState({
        previewImage: file.url || file.thumbUrl,
        previewVisible: true
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleChange", function (_ref) {
      var fileList = _ref.fileList,
        onChange = _ref.onChange;
      var validate = fileList.every(function (file) {
        return _this.beforeUpload(file);
      });
      if (!validate) {
        return;
      }
      var isFail = false;
      fileList.forEach(function (el) {
        if (isFail) return;
        if (el.response && el.response.code !== 200) {
          var _el$response$data;
          // 本地预览时code=0，url以//开头，需要特殊处理
          if (!/^\/\//.test((_el$response$data = el.response.data) === null || _el$response$data === void 0 ? void 0 : _el$response$data.url)) {
            _message.error(getLocalText("error.".concat(el.response.i18n_prompt)));
            isFail = true;
          }
        }
      });
      // 如果有失败的
      if (isFail) {
        _this.setState({
          fileList: fileList.filter(function (el) {
            return !!el.url || el.response && el.response.code === 200;
          })
        });
        return;
      }
      _this.setState({
        fileList: fileList
      });
      var _this$state$text = _this.state.text,
        text = _this$state$text === void 0 ? '' : _this$state$text;
      onChange({
        text: text,
        fileList: fileList.map(function (el) {
          var _el$response;
          // localStorage中的答案
          if (el.url) {
            return el.url;
          }
          if ((_el$response = el.response) === null || _el$response === void 0 ? void 0 : _el$response.data) {
            var url = el.response.data.url;
            return /^\/\//.test(url) ? "https:".concat(url) : url;
          }
          // 测试环境假接口格式不一样
          return el.response && el.response.url;
        })
      });
    });
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "handleTextChange", function (text, onChange) {
      _this.setState({
        text: text
      });
      var fileList = _this.state.fileList;
      onChange({
        text: text,
        fileList: fileList.map(function (el) {
          if (el.response && el.response.data) {
            return el.response.data.url;
          }
          // 测试环境假接口格式不一样
          return el.response && el.response.url;
        })
      });
    });
    var answer = props.answer;
    var _fileList = [];
    if (answer && answer.list) {
      answer.list.forEach(function (url, index) {
        _fileList.push({
          uid: "-".concat(index),
          name: '',
          status: 'done',
          url: url,
          thumbUrl: url
        });
      });
    }
    _this.state = {
      fileList: _fileList,
      previewVisible: false,
      previewImage: '',
      text: ''
    };
    return _this;
  }
  _createClass(LongTextPC, [{
    key: "beforeUpload",
    value: function beforeUpload(file) {
      var isBigFile = file.size > 53000000;
      if (isBigFile) {
        _message.error('>50MB');
        return false;
      }
      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        label = _this$props.label,
        question = _this$props.question;
      var _this$state = this.state,
        previewImage = _this$state.previewImage,
        previewVisible = _this$state.previewVisible,
        fileList = _this$state.fileList;
      var uploadButton = React.createElement("div", {
        style: {
          fontSize: 32
        }
      }, React.createElement(IconFont, {
        type: "icon-icon-test1"
      }));
      return React.createElement(UploadCommon, this.props, function (_ref2) {
        var error = _ref2.error,
          host = _ref2.host,
          _onChange = _ref2.onChange,
          max = _ref2.max,
          withText = _ref2.withText,
          placeholder = _ref2.placeholder,
          accept = _ref2.accept;
        return React.createElement(FormItem, {
          label: label,
          validateStatus: error ? 'error' : null,
          hasFeedback: true,
          help: error,
          required: question.required
        }, React.createElement(_Upload, {
          className: fileList.length >= max && 'max',
          accept: accept.join(', '),
          action: host,
          listType: "picture-card",
          fileList: fileList,
          onPreview: _this2.handlePreview,
          onChange: function onChange(_ref3) {
            var fileList = _ref3.fileList;
            return _this2.handleChange({
              fileList: fileList,
              onChange: _onChange
            });
          }
        }, fileList.length >= max ? null : uploadButton), React.createElement(_Modal, {
          visible: previewVisible,
          footer: null,
          onCancel: _this2.handleCancel
        }, React.createElement("img", {
          alt: "example",
          style: {
            width: '100%'
          },
          src: previewImage,
          loading: "lazy"
        })), withText && React.createElement(_Input.TextArea, {
          placeholder: placeholder,
          onChange: function onChange(e) {
            return _this2.handleTextChange(e.target.value.substring(0, 500), _onChange);
          }
        }));
      });
    }
  }]);
  return LongTextPC;
}(Component);
export { LongTextPC as default };